import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { pdfjs } from "react-pdf";
import _ from "lodash";
import ViewUserDocuments from "../common/ViewUserDocuments";
import {
  getImageURLMapping,
  getImageURL
} from "../../util/candidateDataFilters";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "../../styles/attachments.css";
import CDKSpinner from "../../images/CDKSpinner.gif";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default class FilesUploadComponent extends Component {
  imageURLMapping = getImageURLMapping(this.props.userDocuments);

  onDrop = acceptedFiles => {
    let concatFiles = _.unionBy(
      this.props.userDocuments,
      acceptedFiles,
      "name"
    );
    this.imageURLMapping = concatFiles
      .filter(file => file.type !== "application/pdf")
      .map(image => {
        return {
          url: getImageURL(this.imageURLMapping, image),
          name: image.name
        };
      });

    this.props.setUserDocuments(concatFiles);
  };
  render() {
    let invalidFileTypes = [];
    let fileTooLarge = [];
    return (
      <div className="container pt-5 pb-3">
        <Dropzone
          onDrop={this.onDrop}
          accept="application/pdf"
          minSize={0}
          maxSize={1048576}
          multiple
        >
          {({
            getRootProps,
            getInputProps,
            isDragActive,
            isDragReject,
            fileRejections
          }) => {
            fileRejections.map(rejected =>
              rejected.errors.map(err =>
                err.code === "file-too-large"
                  ? fileTooLarge.push(rejected.file.name)
                  : invalidFileTypes.push(rejected.file.name)
              )
            );
            invalidFileTypes = _.uniq(invalidFileTypes);
            fileTooLarge = _.uniq(fileTooLarge);
            return (
              <div {...getRootProps({ className: "dropzone on-hover" })}>
                <input {...getInputProps()} />
                {/* <div className="d-flex justify-content-center mt-5">
                  <Icon className="icon-upload pr-4">image</Icon>
                  <Icon className="icon-upload">picture_as_pdf</Icon>
                </div> */}
                <div className="text-center py-5">
                  {!isDragActive && "Click here or drop a files to upload!"}
                  {isDragActive && !isDragReject && "Drop here to Upload"}
                  {isDragActive && isDragReject && (
                    <p className="text-danger">
                      Invalid File Type or File Size exceeds 1 MB
                    </p>
                  )}
                  {invalidFileTypes.length > 0 && (
                    <div className="text-danger mt-2">{`${invalidFileTypes.join(
                      " ,"
                    )} must be in pdf format`}</div>
                  )}
                  {fileTooLarge.length > 0 && (
                    <div className="text-danger mt-2">{`${fileTooLarge.join(
                      " ,"
                    )} must be less than 1 MB`}</div>
                  )}
                </div>
              </div>
            );
          }}
        </Dropzone>

        {this.props.documentsLoading && (
          <div className="d-flex align-items-center justify-content-center">
            <img
              src={CDKSpinner}
              className="pt-5 "
              alt="Loading Documents..."
            />
          </div>
        )}

        <ViewUserDocuments
          userDocuments={this.props.userDocuments}
          setUserDocuments={this.props.setUserDocuments}
        />
      </div>
    );
  }
}
